import { connect } from "react-redux";

import { setRegretSwipeVisibility } from "ducks/quickmatch";
import RegretSwipeAlert from "./RegretSwipeAlert";

function mapStateToProps(state) {
	const { quickmatch } = state;

	return {
		isOpen: quickmatch?.isRegretSwipeOpen,
	};
}

const mapDispatchToProps = {
	onClose: () => setRegretSwipeVisibility(false),
};

export default connect(mapStateToProps, mapDispatchToProps)(RegretSwipeAlert);



// WEBPACK FOOTER //
// ./src/shared/components/RegretSwipeAlert/index.js